import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/bootstrap';
import * as fromAccessGroupActions from './access-group.actions';
import { AccessGroup } from './access-group.model';

export interface AccessGroupFilters extends BaseObjectFilters {
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: AccessGroup };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromAccessGroupActions.Actions): State {
    switch (action.type) {
        case fromAccessGroupActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromAccessGroupActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromAccessGroupActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.reducer.ts